import pdfMake from "pdfmake/build/pdfmake";
import pdfMakeUnicode from 'pdfmake-unicode';
pdfMake.vfs = pdfMakeUnicode.pdfMake.vfs;

import getDocDefinition from "./docDefinition";
import getColGroupDocDefinition from "./docDefinitionColGroups";

export function printDoc(printParams, gridApi, exportFileName) {
  const docDefinition = getDocDefinition(printParams, gridApi);
  try{
    pdfMake.createPdf(docDefinition).download(exportFileName);
  }catch (event){
    console.error('Error generating PDF. ',event);
  }

}

export function  printDocWithColGroups(printParams, gridApi, exportFileName, aggregateLevelDepth) {
  const docDefinition = getColGroupDocDefinition(printParams, gridApi, aggregateLevelDepth, exportFileName);
  try{
    pdfMake.createPdf(docDefinition).download(exportFileName);
  }catch (event){
    console.error('Error generating PDF. ',event);
  }

}
